// react_projekat/src/components/navigation/MainNavigation/GroupNavigationMob/GroupNavigationMob.tsx

import React from "react";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import NavItemSmallScreen from "../MainNavigationSmallScreen/NavItemSmallScreen";
import type { DlGroup } from "constant/dl_group/dl_group.constant";
import { DL_GROUPS } from "constant/dl_group/dl_group.constant";
import { NavElement } from "type/navigation/main_navigation.type";

type GroupNavigationMobProps = {
  clickHandle: () => void;
};

type NavItemProps = {
  navItem: NavElement;
};

const GroupNavigationMob = ({ clickHandle }: GroupNavigationMobProps) => {
  const { slug } = useParams<{ slug: string }>();

  if (!slug || !DL_GROUPS[slug]) return null;

  const NavItem = ({ navItem }: NavItemProps) => {
    return <NavItemSmallScreen navItem={navItem} clickHandle={clickHandle} />;
  };

  const group: DlGroup = DL_GROUPS[slug];

  return (
    <Wrapper>
      <NavItem navItem={{ path: `/g/${slug}`, title: group.linkLabelMob }} />
      <NavItem
        navItem={{ path: `/g/${slug}/kd`, title: "izložbeni katalozi" }}
      />
      <NavItem navItem={{ path: `/g/${slug}/d`, title: "knjige" }} />
      <NavItem navItem={{ path: `/g/${slug}/p`, title: "periodika" }} />
      <NavItem navItem={{ path: `/g/${slug}/hm`, title: "hemeroteka" }} />
      <NavItem
        navItem={{
          path: `/g/${slug}/photo-series/ph`,
          title: "fotodokumentacija",
        }}
      />
      <NavItem
        navItem={{
          path: `/g/${slug}/photo-series/ng`,
          title: "neknjižna građa",
        }}
      />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 0;
`;

export default GroupNavigationMob;
